import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const getAllIM_INV = () => {
    return httpClient.get(server.IM_INV + `/`);
};

export const CreateIM_INV = (data) => {
    return httpClient.post(server.IM_INV, data);
};

export const updateIM_INV = (id, data) => {
    return httpClient.put(server.IM_INV + `/${id}`, data);
};


export const DeleteIM_INV = (id) => {
    return httpClient.delete(server.IM_INV +`/${id}`);
};
